module.exports = __webpack_public_path__ + "static/CFG_Artist_Willowbrook-00ae1c796991623131dc3977efea56c3.jpg";